import { Component, Input, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AddRateComponent } from '../../matters/matter-popup/rates/add-rate/add-rate.component';
import { ToastrService } from 'ngx-toastr';
import { BehaviorService } from '@_services/Behavior.service';
import { MainAPiServiceService } from '@_services/main-api-service.service';
import { Subscription } from 'rxjs';
import { FuseConfirmDialogComponent } from '@/app/Shared/confirm-dialog/confirm-dialog.component';
import { DIALOG_WIDTH } from '@/app/_constant/dialog-width.constants';

@Component({
  selector: 'app-matter-rates',
  templateUrl: './matter-rates.component.html',
  styleUrls: ['./matter-rates.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MatterRatesComponent implements OnInit, OnDestroy {
  @Input() SettingForm: FormGroup;
  @Input() errorWarningData: any;
  Classdata: any = [];
  UserRateData: any = [];
  ActivityRateData: any = [];
  isLoadingResults: boolean = false;
  matterGuid: any;
  sub: Subscription;
  currentUser = JSON.parse(localStorage.getItem('currentUser'));
  sub1: Subscription;
  constructor(
    private behaviorService: BehaviorService,
    public dialog: MatDialog,
    private _mainAPiServiceService: MainAPiServiceService,
    private toastr: ToastrService,
  ) {
    localStorage.setItem('istrackid', 'SystemSettingMatterRatesComponent');
  }

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit() {
    this.isLoadingResults = true;
    this.behaviorService.loadingSystemSetting('matter-class-rates');
    let MatterClassLookups = localStorage.getItem('matter_class_lookups');
    if (MatterClassLookups && MatterClassLookups != 'null') {
      this.Classdata = JSON.parse(MatterClassLookups);
      if (this.Classdata[0]) {
        this.matterGuid = this.Classdata[0].LOOKUPGUID;
        this.loadRateDate('user-rate');
      }
    } else {
      this.sub = this._mainAPiServiceService
        .getSetData(
          {
            Action: 'getdata',
            Filters: { LookupType: 'Matter Class' },
          },
          'lookup',
        )
        .subscribe((responses) => {
          if (responses.CODE === 200 && responses.STATUS === 'success') {
            this.Classdata = responses.DATA.LOOKUPS;
            localStorage.setItem('matter_class_lookups', JSON.stringify(responses.DATA.LOOKUPS));
            if (responses.DATA.LOOKUPS[0]) {
              this.matterGuid = responses.DATA.LOOKUPS[0].LOOKUPGUID;
              this.loadRateDate('user-rate');
            }
          }
          this.isLoadingResults = false;
        });
    }
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    this.sub1?.unsubscribe();
  }

  /**
   * This function is used to AddNew  Rate
   */
  AddNewRate(actions, type, id) {
    const dialogRef = this.dialog.open(AddRateComponent, {
      disableClose: true,
      data: {
        formAction: actions,
        USERRATEGUID: id,
        rateType: 'Matter Class',
        linkGuid: this.matterGuid,
        type: type,
      },
      panelClass: 'dialog-panel-class',
      backdropClass: 'cdk-overlay-dark-backdrop',
    });
    dialogRef.afterClosed().subscribe((result) => {
      localStorage.setItem('istrackid', 'SystemSettingMatterRatesComponent');
      if (result) {
        this.loadRateDate(result);
      }
    });
  }

  /**
   * This function is used to Delete the rates
   */
  DeleteRate(item) {
    let confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
      disableClose: true,
      width: DIALOG_WIDTH.FULL,
      panelClass: 'dialog-panel-class',
      backdropClass: 'cdk-overlay-dark-backdrop',
    });
    confirmDialogRef.componentInstance.confirmMessage = 'Are you sure you want to delete?';
    confirmDialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this._mainAPiServiceService
          .getSetData(
            {
              ACTION: 'delete',
              VALIDATEONLY: false,
              DATA: { USERRATEGUID: item.USERRATEGUID },
            },
            'user-rate',
          )
          .subscribe(
            (response) => {
              if (
                response.CODE == 200 &&
                (response.STATUS == 'OK' || response.STATUS == 'success')
              ) {
                this.toastr.success('User rate deleted successfully');
                this.loadRateDate('user-rate');
              }
            },
            (error: any) => {
              console.error(error);
            },
          );
      }
      confirmDialogRef = null;
    });
  }
  get f() {
    return this.SettingForm.controls;
  }

  /**
   * This function is used to load the rates data
   */
  loadRateDate(rateType) {
    this.isLoadingResults = true;
    let payload: any = {
      Action: 'GetData',
    };

    if (rateType == 'user-rate') {
      payload.Filters = {
        RATETYPE: 'Matter Class',
        LINKGUID: this.matterGuid,
      };
    } else if (rateType == 'activity-rate') {
      payload = { RATETYPE: 'Matter Class', LINKGUID: this.matterGuid };
    }

    this.sub1 = this._mainAPiServiceService.getSetData(payload, rateType).subscribe((responses) => {
      if (responses.CODE == 200 && responses.STATUS == 'success') {
        if (rateType == 'user-rate') {
          this.UserRateData = responses.DATA.RECORDS;
        } else if (rateType == 'activity-rate') {
          this.ActivityRateData = responses.DATA.ActivityRateData;
        }
        this.isLoadingResults = false;
      }
    });
  }

  /**
   * This function is used to Currency Class change
   */
  CurrencyClassChange(event) {
    this.matterGuid = event.LOOKUPGUID;
    this.loadRateDate('user-rate');
  }
}
